import React from 'react';
import CTACard from '../CTACard/CTACard';
import './CTASection.css';

const cardsData = [
  {
    image: 'https://st3.depositphotos.com/1518767/14725/i/600/depositphotos_147255091-stock-photo-customer-service-executive-working.jpg',
    altText: 'A legacy of excellence',
    title: 'A legacy of excellence',
    description: 'Since 1991, Pharm-Rx has grown from a single vision to a global leader in ingredient sourcing, maintaining our commitment to quality, innovation, and customer service.',
    link: 'http://localhost:3000/about#our-story',
    linkText: 'See more of our story',
  },
  {
    image: 'https://st.depositphotos.com/1901857/4924/i/950/depositphotos_49243739-stock-photo-interior-of-new-large-and.jpg',
    altText: 'The complete ingredient solution',
    title: 'The complete ingredient solution',
    description: 'With Pharm-Rx, you have access to a vast selection of ingredients, from everyday essentials to specialty items, all sourced to meet your exact requirements.',
    link: 'https://www.pharm-rx.store/products',
    linkText: 'Browse all products',
  },
  {
    image: 'https://static8.depositphotos.com/1545817/1006/i/950/depositphotos_10063991-stock-photo-scientist-conducting-research-with-microscope.jpg',
    altText: 'Quality you can trust',
    title: 'Quality you can trust',
    description: 'Supported by FDA compliance and industry-leading certifications, Pharm-Rx delivers ingredients that meet rigorous scientific and regulatory standards.',
  },
];

const CTASection = () => {
  return (
    <div className="cta-section">
      {cardsData.map((card, index) => (
        <CTACard key={index} {...card} reverse={index % 2 !== 0} />
      ))}
    </div>
  );
};

export default CTASection;
